var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_447_21849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.256 99.7688C122.22 77.8051 122.22 42.1949 100.256 20.2312C78.2927 -1.73243 42.6826 -1.73243 20.7189 20.2312C-1.24476 42.1949 -1.24476 77.8051 20.7189 99.7688C42.6826 121.732 78.2927 121.732 100.256 99.7688Z",
    fill: "#0D6EFD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.941 69.5444C111.938 92.9632 93.4607 111.44 70.0426 115.442L39.7612 85.1609C32.515 79.1808 27.8966 70.1309 27.8966 60.0021C27.8966 41.9953 42.4935 27.3984 60.5003 27.3984C70.629 27.3984 79.679 32.017 85.659 39.263L115.941 69.5444Z",
    fill: "#0043A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2392 61.938L54.5247 70.4651C55.8791 71.712 57.9756 71.6456 59.2494 70.3322L75.8148 54.4718C77.1622 53.1762 77.203 51.0326 75.9069 49.6845C74.6108 48.3384 72.4684 48.2962 71.121 49.5919L56.7721 63.3302L49.8264 56.9522C48.4504 55.6861 46.3065 55.7749 45.0397 57.1523C43.7732 58.5284 43.8625 60.6708 45.2392 61.938ZM60.5003 27.3984C78.5071 27.3984 93.104 41.9953 93.104 60.0021C93.104 78.0089 78.5071 92.6058 60.5003 92.6058C42.4935 92.6058 27.8966 78.0089 27.8966 60.0021C27.8966 41.9953 42.4935 27.3984 60.5003 27.3984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_447_21849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.48037bff1ce940b040b74c9ed4dbcac8.svg";
export { ForwardRef as ReactComponent };